/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="admin_menu_top_unit menu_center">

            <Message v-if="ApivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
            <Message :validationMessage="ApivalidationMessage" />

            <form class="form_store"  v-on:submit.prevent="onsubmit">
                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storename">店舗名</label>
                </div>
                <div class="input_store left_comment">
                    <input class="wd400" id="storename" name="storename" type="text" v-model="addStoreForm.store_name" maxlength="20"/><br>
                    <label id="storenameerror" class="lavel_error_font ">{{validation.storenameReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storepostalcode">郵便番号</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd240" id="storepostalcode" name="storepostalcode" type="text" v-model="addStoreForm.zip_code" maxlength="7"/><br>
                    <label>半角数字(ハイフンなし)で入力してください。</label>
                    <label id="storepostalcodeerror" class="lavel_error_font ">{{validation.zipcodeReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storeaddress">店舗住所</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd400" id="storeaddress" name="storeaddress" type="text" v-model="addStoreForm.address" maxlength="40"/><br>
                    <label id="storeaddresserror" class="lavel_error_font ">{{validation.addressReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <label for="storeｒemarks">備考欄</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd400" id="storeｒemarks" name="storeｒemarks" type="text" v-model="addStoreForm.remarks" maxlength="20"/><br>
                    <label id="storeｒemarkserror" class="lavel_error_font ">{{validation.remarksReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storetell">連絡先電話番号</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd240" id="storetell" name="storetell" type="text" v-model="addStoreForm.phone_number" maxlength="11"/><br>
                    <label>半角数字(ハイフンなし)で入力してください。</label>
                    <label id="storetellerror" class="lavel_error_font ">{{validation.phonenumberReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <label for="storetell">アラート通知先</label>
                </div>
                <div class="input_store left_comment">
                  <div v-for="(email, index) in addStoreForm.anomaly_mail" :key="index" class="d-flex align-items-start mgb_10">
                    <input  class="wd240" :id="'storeanomalymail'+index" name="storeanomalymail" type="text" v-model="addStoreForm.anomaly_mail[index]"/><br>
                    <div v-if="index == 0" class="storeSetting_kanri_box ">
                      <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="addColum">枠追加</a></li></ul>
                    </div>
                    <div v-if="index != 0" class="storeSetting_kanri_box ">
                      <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="deleteColum(index)">削除</a></li></ul>
                    </div>
                    <label id="storeanomalymailerror" class="lavel_error_font ">{{validation.anomalymailResult}}</label>
                  </div>
                </div>

                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storperson">店舗管理者氏名</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd240" id="storperson" name="storperson" type="text" v-model="addStoreForm.admin_name" maxlength="20"/><br>
                    <label id="storpersonerror" class="lavel_error_font ">{{validation.adminnameReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storepass">管理者パスワード</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd240" id="storepass" name="storepass" type="password" v-model="addStoreForm.password"  maxlength="128"/><br>
                    <label>8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                    <label id="storepasserror" class="lavel_error_font ">{{validation.storeypassReult}}</label>
                </div>

                <div class="lavel_store right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="storepass2">管理者パスワード(確認)</label>
                </div>
                <div class="input_store left_comment">
                    <input  class="wd240" id="storepass2" name="storepass2" type="password" v-model="addStoreForm.password_confirm"  maxlength="128"/><br>
                    <label id="storepass2error" class="lavel_error_font ">{{validation.storerepassReult}}</label>
                </div>

            </form>
        </div>
        <div class="btn_submit letter_spa">
            <a href="#" @click.prevent.stop="checkFrom">登録</a>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">店舗登録</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>店舗登録が完了しました。<br></p>
                        トップ画面に戻り、設定メニューを選び、
                        今登録した管理者パスワードで再度ログインしてください
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'StoreAdd',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            isLoading:false,
            brandId: '',
            showContent:false,
            addStoreForm: {
                store_name: null,
                zip_code: null,
                address: null,
                remarks: null,
                phone_number: null,
                admin_name: null,
                password: null,
                password_confirm: null,
                anomaly_mail: [""]
            },
            validation:{
                storenameReult: "",
                zipcodeReult: "",
                addressReult: "",
                remarksReult: "",
                phonenumberReult: "",
                adminnameReult: "",
                storeypassReult: "",
                storerepassReult: "",
                anomalymailResult: ""
            },
            addFormFlg: true
        }
    },
    created () {
        //ブランドIDを取得
        this.brandId = this.$store.getters['manager/manager'].brandId;
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
    },
    methods:{
        checkFrom: async function(){

            this.addFormFlg = true;
            this.isLoading = true;

            //エラー内容初期化
            this.clearError();

            //バリデーションチェック(企業コード)
            //必須チェック
            if(!this.addStoreForm.store_name){
                this.validation.storenameReult="店舗名を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addStoreForm.zip_code){
                this.validation.zipcodeReult="郵便番号を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addStoreForm.address){
                this.validation.addressReult="店舗住所を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addStoreForm.phone_number){
                this.validation.phonenumberReult="連絡先電話番号を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addStoreForm.admin_name){
                this.validation.adminnameReult="店舗管理者氏名を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addStoreForm.password){
                this.validation.storeypassReult="管理者パスワードを入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addStoreForm.password_confirm){
                this.validation.storerepassReult="管理者パスワード(確認)を入力してください。"
                this.addFormFlg = false;
            }

            //桁数チェック
            if(String(this.addStoreForm.store_name).length > 20 && this.validation.storenameReult ==""){
                this.validation.storenameReult="店舗名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addStoreForm.zip_code).length !== 7 && this.validation.zipcodeReult == ""){
                this.validation.zipcodeReult="郵便番号は7桁で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addStoreForm.address).length > 40 && this.validation.addressReult == ""){
                this.validation.addressReult="店舗住所は40桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addStoreForm.remarks).length > 20 && this.validation.remarksReult == ""){
                this.validation.remarksReult="備考欄は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if((String(this.addStoreForm.phone_number).length < 10 || String(this.addStoreForm.phone_number).length > 11) && this.validation.phonenumberReult == ""){
                this.validation.phonenumberReult="連絡先電話番号は10桁以上11桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addStoreForm.admin_name).length >20 && this.validation.adminnameReult == ""){
                this.validation.adminnameReult="店舗管理者氏名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if((String(this.addStoreForm.password).length < 8 || String(this.addStoreForm.password).length > 128 ) && this.validation.storeypassReult == "" ){
                this.validation.storeypassReult="管理者パスワードは8桁以上、128桁以内で入力してください。"
                this.addFormFlg = false;
            }



            //文字種チェック
            if(this.addStoreForm.store_name !== null && !this.checkStrong2(this.addStoreForm.store_name) && this.validation.storenameReult == ""){
                this.validation.storenameReult="店舗名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addStoreForm.zip_code !== null && !this.checkNumberZipCode(this.addStoreForm.zip_code) && this.validation.zipcodeReult == ""){
                this.validation.zipcodeReult="郵便番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addStoreForm.address !== null && !this.checkAddress(this.addStoreForm.address) && this.validation.addressReult == ""){
                this.validation.addressReult="店舗住所は全半角英数漢ひらカナ記号（・ー-）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addStoreForm.remarks !== null && !this.checkStrong2(this.addStoreForm.remarks) && this.validation.remarksReult == ""){
                this.validation.remarksReult="備考欄は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addStoreForm.phone_number !== null && !this.checkNumber(this.addStoreForm.phone_number) && this.validation.phonenumberReult == ""){
                this.validation.phonenumberReult="連絡先電話番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.addStoreForm.admin_name !== null && !this.checkStrong2(this.addStoreForm.admin_name) && this.validation.adminnameReult == ""){
                this.validation.adminnameReult="店舗管理者氏名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addStoreForm.password!== null && !this.checkStrong4(this.addStoreForm.password) && this.validation.storeypassReult == ""){
                this.validation.storeypassReult="管理者パスワードは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }


            //pwチェック
            if(this.addStoreForm.password !== this.addStoreForm.password_confirm && this.validation.storeypassReult == ""){
                this.validation.storeypassReult="パスワードが一致しません。入力しなおしてください。"
                this.addFormFlg = false;
            }

            // バリデーション
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            if(this.addFormFlg == true){

                var apiResponseFlg = true;

                // 店舗情報の登録
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/create', this.addStoreForm)
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                    this.openModel()
                }
            }
        },
        //半角英数字のチェック
        checkStrong:function(inputdata){
            var re = new RegExp(/^[A-Za-z0-9]*$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumber:function(inputdata){
            var re = new RegExp(/^[0-9]*$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumberZipCode:function(inputdata){
            var re = new RegExp(/^[0-9]{7}$/);
            return re.test(inputdata);
        },
        //全半角英数漢ひらカナ
        checkStrong2:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpace);
            return re.test(inputdata);
        },
        //半角英数記号
        checkStrong4:function(inputdata){
            var re = new RegExp(/^[0-9a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/);
            return re.test(inputdata);
        },
        //住所（全半角英数漢ひらカナ記号（・ー-））
        checkAddress:function(inputdata){
            var re = new RegExp(ValidationRule.Address);
            return re.test(inputdata);
        },
        clearError:function(){
            //メッセージ初期化
            this.validation.storenameReult = "";
            this.validation.zipcodeReult = "";
            this.validation.addressReult = "";
            this.validation.remarksReult = "";
            this.validation.phonenumberReult = "";
            this.validation.adminnameReult = "";
            this.validation.storeypassReult = "";
            this.validation.storerepassReult = "";
            this.ApivalidationMessage = "";
            this.validation.anomalymailResult = "";
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'manageStoreList', params: {brandPath: this.brandPath}});
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        addColum(){
          if(this.addStoreForm.anomaly_mail.length < 16 ) {
            this.addStoreForm.anomaly_mail.push('')
          }
        },
        deleteColum(index){
          this.addStoreForm.anomaly_mail.splice(index,1);
        }
    }
}
</script>